export default {
  'initial.dataset.pie3d': function () {
    return {
      'group.appearing': (inputJSON) => {
        if (inputJSON.attr.name === 'plots') {
          return [{
            initialAttr: {
              opacity: '0'
            },
            finalAttr: {
              opacity: '1'
            },
            slot: 'plot'
          }];
        } else {
          return [{
            initialAttr: {
              opacity: '1'
            },
            finalAttr: {
              opacity: '1'
            },
            slot: 'final'
          }];
        }
      },
      'slice.appearing': [{
        initialAttr: {
          opacity: '1'
        },
        slot: 'plot'
      }],
      'label.updating': [{
        initialAttr: {
          opacity: '1'
        },
        finalAttr: {
          opacity: '1'
        },
        slot: 'final'
      }],
      'label.appearing': [{
        initialAttr: {
          opacity: '0'
        },
        finalAttr: {
          opacity: '1'
        },
        slot: 'final'
      }],
      'connector.updating': (inputJSON) => {
        return [{
          initialAttr: {
            path: inputJSON.el.attr('path') || inputJSON.attr.path,
            opacity: inputJSON.el.attr('opacity')
          },
          finalAttr: {
            path: inputJSON.attr.path
          },
          slot: 'final'
        }];
      },
      'connector.appearing': (inputJSON) => {
        let initialAttr;
        if (typeof inputJSON.el === 'string') {
          initialAttr = {opacity: '0'};
        } else {
          initialAttr = {
            path: inputJSON.attr.path,
            opacity: '0'
          };
        }
        return [{
          initialAttr: initialAttr,
          slot: 'final'
        }];
      },
      'connector-sliced.updating': (inputJSON) => {
        return [{
          initialAttr: {
            path: inputJSON.el.attr('path')
          },
          finalAttr: {
            path: inputJSON.attr.path
          },
          slot: 'plot'
        }];
      },
      'label-sliced.updating': (inputJSON) => {
        return [{
          initialAttr: {
            x: inputJSON.el.attr('x'),
            y: inputJSON.el.attr('y')
          },
          slot: 'plot'
        }];
      },
      '*': null
    };
  }
};
